import { PlayCircleIcon } from "app/components/Icons";
import PauseCircleIcon from "app/components/Icons/PauseCircleIcon";
import CustomTooltip from "app/components/Tooltip";
import React, { ComponentProps, FC } from "react";

type TimeTrackerStatusIconProps = {
  size: number;
  timerIconProps?: ComponentProps<"div">;
  isActive: boolean;
};

export const TimeTrackerStatusIcon: FC<TimeTrackerStatusIconProps> = ({
  size,
  timerIconProps,
  isActive,
}) => {
  // Variables
  const iconSizeInPixels = `${size}px`;
  const iconColor = "#EB5757";
  const iconStyle = {
    minWidth: iconSizeInPixels,
    width: iconSizeInPixels,
    maxWidth: iconSizeInPixels,
    minHeight: iconSizeInPixels,
    height: iconSizeInPixels,
    maxHeight: iconSizeInPixels,
    color: iconColor,
  };

  return (
    <div
      style={timerIconProps?.style ? iconStyle : undefined}
      onPointerDown={(e) => e.stopPropagation()}
      role="button"
      {...timerIconProps}
    >
      <CustomTooltip
        text={isActive ? "Stop Timer" : "Start Timer"}
        position="bottom"
        className="flex items-center justify-center"
      >
        {isActive ? (
          <PauseCircleIcon size={size} color={iconColor} />
        ) : (
          <PlayCircleIcon size={size} color={iconColor} />
        )}
      </CustomTooltip>
    </div>
  );
};
